import { call, put, takeLatest } from "redux-saga/effects";
import { DashboardActions } from "../../action-types/dashboardActionTypes";
import {
  setCompletedChecklistCountList,
  setDefectreportAllVesselCategoryList,
  setDefectreportAllVesselList,
  setDefectreportByVesselList,
  setDashboardUnreadDefectList,
} from "../../actions/dashboardAction";
import {
  getCompletedChecklistCountApi,
  getDefectreportAllVesselApi,
  getDefectreportAllVesselcategoryApi,
  getDefectreportByVesselgraphApi,
  getDashboardUnreadDefectListApi,
} from "../requests/dashboardRequests";
import { setLoader } from "../../actions/userActions";
import { toast } from "react-toastify";

function* getDefectreportByVesselgraphHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(
      getDefectreportByVesselgraphApi,
      action.payload
    );
    if (data) {
      yield put(setDefectreportByVesselList(data.graphData));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* getCountByVesselgraphHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getCompletedChecklistCountApi, action.payload);
    if (data) {
      yield put(setCompletedChecklistCountList(data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* getDefectreportAllVesselgraphHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getDefectreportAllVesselApi, action.payload);
    if (data) {
      yield put(setDefectreportAllVesselList(data.graphData));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* getDefectreportAllVesselCategorygraphHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(
      getDefectreportAllVesselcategoryApi,
      action.payload
    );
    if (data) {
      yield put(setDefectreportAllVesselCategoryList(data.graphData));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* getDashboardUnreadDefectHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getDashboardUnreadDefectListApi);
    if (data) {
      yield put(setDashboardUnreadDefectList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

// accountHandler Sagas
export default function* dashboardSaga() {
  yield takeLatest(
    DashboardActions.GET_DASHBOARD_DEFECT_REPORT_LIST,
    getDefectreportByVesselgraphHandler
  );
  yield takeLatest(
    DashboardActions.GET_COMPLETE_CHECK_LIST_COUNT_LIST,
    getCountByVesselgraphHandler
  );
  yield takeLatest(
    DashboardActions.GET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_LIST,
    getDefectreportAllVesselgraphHandler
  );
  yield takeLatest(
    DashboardActions.GET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_CATEGORY_LIST,
    getDefectreportAllVesselCategorygraphHandler
  );
  yield takeLatest(
    DashboardActions.GET_DASHBOARD_UNREAD_DEFECT_LIST,
    getDashboardUnreadDefectHandler
  );
}
